import { createContext, useContext, useState, type ReactNode } from "react";
import { useCanvasStore } from "@/store/useCanvasStore";

interface ViewportCtxValue {
  forgeId: string | null;
  setForgeId: (id: string) => void;
}

export const ViewportCtx = createContext<ViewportCtxValue | null>(null);

export function ViewportCtxProvider({ children }: { children: ReactNode }) {
  // Seed from the forge the canvas store rehydrated out of localStorage.
  // Starting at null instead meant a cold load painted the persisted canvas
  // while AppShell's `if (!forgeId) return` skipped both the refetch and the WS
  // connect: a stale canvas with no live socket, so no MCP write ever arrived
  // until the user re-picked the forge in the sidebar.
  const [forgeId, setForgeId] = useState<string | null>(
    () => useCanvasStore.getState().forgeId,
  );
  return (
    <ViewportCtx.Provider value={{ forgeId, setForgeId }}>
      {children}
    </ViewportCtx.Provider>
  );
}

export function useViewportCtx(): ViewportCtxValue {
  const ctx = useContext(ViewportCtx);
  if (!ctx) throw new Error("useViewportCtx: missing ViewportCtxProvider");
  return ctx;
}
